<template>
  <div class="card-image">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'card-image'
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";

.card-image {
  margin: 0;
  padding: 0;
  &.-green {
    border-bottom: 4px solid $green;
  }
  &.-blue {
    border-bottom: 4px solid $blue;
  }
  &.-orange {
    border-bottom: 4px solid $orange;
  }
  >img {
    vertical-align:bottom;
  }
}

.card-box {
  >.-underline:hover {
    text-decoration: underline;
    >.card-header {
      >.card-image {
        img {
          opacity: 0.75;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/card/CardImage.vue